import { apiClient, type ApiClient } from '@sidd/chatbot-core'
import type { IWebDirectChatbotConfig } from './types'

const CONFIG_TIMEOUT_MS = 10000 // 10 second timeout for config fetch

export class WebDirectChatbotApi {
  static async getBySlug(
    slug: string,
    client: ApiClient = apiClient
  ): Promise<IWebDirectChatbotConfig> {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), CONFIG_TIMEOUT_MS)

    try {
      const response = await client.get<IWebDirectChatbotConfig>(
        `/api/v1/chatbots/webdirect/${slug}`,
        {
          signal: controller.signal,
        }
      )
      if (!response.data) {
        throw new Error('Invalid response from server')
      }
      return response.data
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') {
        throw new Error('Request timed out. Please try again.', {
          cause: error,
        })
      }
      throw error
    } finally {
      clearTimeout(timeoutId)
    }
  }
}
